import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f644f38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "controls" }
const _hoisted_3 = { class: "inputs" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Schematic ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Comment ")

import { drawSVG, parse } from './CircuitAnalyzer';
import { inject, ref } from "vue";
import { toastInjectionKey } from '../Toaster/ToastManager';
import { circuitConfigInjectionKey } from './CircuitManager';

interface Emits{
    (e: 'finish', v: void): void;
}
/* eslint-disable-next-line */

export default /*#__PURE__*/_defineComponent({
  __name: 'CircuitCreator',
  emits: ["finish"],
  setup(__props, { emit }: { emit: ({
    (e: 'finish', v: void): void;
}), expose: any, slots: any, attrs: any }) {

const toaster = inject(toastInjectionKey);
const circuitStore = inject(circuitConfigInjectionKey);

const result = ref(null);
const invalid = ref(false);

const schematic = ref("");
const comment  = ref("");


const draw = function(e:Event){
    const input = (e.currentTarget as HTMLInputElement).value;
    if(!input){
        return;
    }
    if(!result.value){
        return;
    }

    try{
        const node = parse(input);
        if(!node){
            invalid.value = true;
            return;
        }
        if(node.comment === "unknown included"){
            invalid.value = true;
        }else{
            invalid.value = false;
        }
        const svg = drawSVG(node);
        
        //svg.setAttribute("height", rect.height.toString());

        //reset
        (result.value as HTMLElement).innerHTML = "";
        (result.value as HTMLElement).appendChild(svg);
    }
    catch{
        console.log("parse error");
        invalid.value = true;
    }
}



const add = function(){
    if(invalid.value || !schematic.value){
        toaster?.alert("Circuit Schematic Error", "", 2000);
        return;
    }
    if(!comment.value){
        comment.value = "No Title";
    }

    circuitStore?.add_circuit(schematic.value, comment.value);
    
    schematic.value = "";
    comment.value = "";
    if(result.value){
        (result.value as HTMLElement).innerHTML = "";
    }
    emit("finish");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", null, [
          _hoisted_4,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((schematic).value = $event)),
            class: _normalizeClass(["schematic", {invalid: invalid.value}]),
            onKeyup: draw
          }, null, 34), [
            [_vModelText, schematic.value]
          ])
        ]),
        _createElementVNode("label", null, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((comment).value = $event)),
            class: "comment"
          }, null, 512), [
            [_vModelText, comment.value]
          ])
        ])
      ]),
      _createElementVNode("button", { onClick: add }, "Add")
    ]),
    _createElementVNode("div", {
      ref_key: "result",
      ref: result,
      class: "display"
    }, null, 512)
  ]))
}
}

})